import axios from 'axios';
import { getFieldService, getRecordService } from '../apiCommon.js';

export const fetchRecordTypes = async (app, context) => {
  const service = getRecordService(app);
  const query = context ? { context } : {};
  const { data } = await service.find({ query });

  return data;
};

export const getRecordFields = async (app, context) => {
  const service = getFieldService(app);
  const { data } = await service.get(context);

  return data;
};

export const getRecordField = async (app, opts) => {
  const { context, field } = opts;
  const service = getFieldService(app);
  const { data } = await service.get(`${context}/${field}`);

  return data;
};

export const getRecordFieldAxios = async (params, opts) => {
  const { field, recordType } = params;
  const { token, host } = opts;

  const { data } = await axios.get(`/field/${recordType}/${field}`, {
    baseURL: host,
    headers: {
      authorization: token,
    },
  });

  return data.data;
};
